// extracted by mini-css-extract-plugin
module.exports = {"root":"_41bbd5","textUp":"_4c95b3","withUpContainer":"_44c902","xs":"_642487"};